import type { ReactElement } from 'react';
import logo from '/images/logo.svg';
import { cn } from '@/lib/utils';
import { useLoginFlowVariant } from './variant';

interface AuthBrandMarkProps {
    /** Describes the step the logo introduces, so the image is not announced as decoration. */
    alt: string;
}

/**
 * Brand mark shown above the heading on every login flow step.
 */
export default function AuthBrandMark({ alt }: AuthBrandMarkProps): ReactElement {
    const variant = useLoginFlowVariant();
    const isPage = variant === 'page';

    return (
        <div className={cn('flex justify-center pt-1', isPage ? 'mb-8 sm:mb-10' : 'mb-6')}>
            <img
                src={logo}
                alt={alt}
                className={cn(
                    'forced-colors:prefer-dark:invert forced-colors:prefer-light:invert-0',
                    isPage ? 'w-32 sm:w-36' : 'w-32'
                )}
            />
        </div>
    );
}
